import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from 'src/app/global.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getEndorsementTypes(code) : Observable<any>{
    return this._http.get<any>(this._global.Baseurl + this._global.getEndorsementTypes+code)
  }

  getDashboardChartService(agentId) : Observable<any>{
    return this._http.get<any>(this._global.Baseurl + this._global.getDashboardChartRouting+agentId)
  }
  
  public getmessage(agentname){
    
    return this._http.get<any>(this._global.Baseurl+this._global.messageRouting+"/"+agentname);
  }
   
  public notificationcount(agentId){
    
    return this._http.get<any>(this._global.Baseurl+this._global.notifiyRouting+"/"+agentId);
  }

  public getPolicyChartservice(obj){
    
    return this._http.post(this._global.Baseurl + this._global.getPolicyChartRouting,obj);
  }

  public getSelectedCharts(obj){
    
    return this._http.post(this._global.Baseurl + this._global.getSelectedChartsRouting,obj);
  }

  public passwordexpiry(username){
    
    return this._http.get(this._global.Baseurl + this._global.getpasswordcrdate+"/"+username);

  }
  public passwordexpirymail(obj){
    
    return this._http.get(this._global.Baseurl + this._global.getpasswordexpmail,obj);
  }

  public getListingChartsservice(obj){
    return this._http.post(this._global.Baseurl + this._global.getListingChartsRouting,obj);

  }

  public dashboardChartdtls(obj){
    
    return this._http.post(this._global.Baseurl + this._global.getCSRDashboardChartsRouting,obj);
   }
}